import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Components/Auth/Login';
import HomePage from './Pages/HomePage';
import GPSPage from './Pages/GPSPage';
import AssetPage from './Pages/AssetPage';
import InventoryPage from './Pages/InventoryPage';
import ResetPassword from './Pages/ResetPassword'; 
import { AppLayout } from './Components/Layout/AppLayout';
import CompanyPage from './Pages/CompanyPage';
import CustomerAccountsPage from './Pages/CustomerAccountsPage';
import LocationPage from './Pages/LocationPage';
import UsersPage from './Pages/UsersPage';
import MapsPage from "./Pages/MapsPage";
import Dashboard from './Pages/Staff/Dashboard';
import { UnauthorizedPage } from './Pages/UnauthorizedPage';
import { ProtectedRoute } from './Components/Auth/ProtectedRoute';
import { RootRouteRedirect } from './Components/Auth/RootRouteRedirect';
import TransactionAuditReport from './Pages/TransactionAuditReport';
import MicrosoftRedirect from './Components/Auth/MicrosoftRedirect';
import { Logout } from './Pages/Logout';
import EmailPage from './Pages/EmailPage';
import Transaction from './Pages/TransactionsPage';
import { SnackbarProvider } from './Context/SnackbarProvider';
import KitsAndToolsPage from './Pages/KitsAndToolsPage';
import { LocationBinPage } from './Pages/LocationBinPage';
import { FleetPage } from './Pages/FleetPage';
import SmsPage from "../src/Components/Auth/SmsPage"
import { TransactionUsage } from './Pages/TransactionUsage';
import { WidgetsPage } from './Pages/WidgetsPage';
import { WidgetPreferencesProvider } from './Context/WidgetPreferencesContext';
import {  AssetTransactionPage } from './Pages/AssetTransactionPage';
import AbatixAdminAuditReport from './Pages/AbatixAdminAuditReport';
import { AssetCategoryPage } from './Pages/AssetCategoryPage';
import FailedOrdersPage from './Pages/FailedOrdersPage';
import LowStockFailedOrdersPage from './Pages/LowStockFailedOrdersPage';
import UsageReportsPage from './Pages/UsageReports/UsageReportsPage';
import DeletedInventoryPage from './Pages/Inventory/DeletedInventoryPage';
import LocationPoPresetsPage from './Pages/Location/LocationPoPresetsPage';
import NonAbatixPage from './Pages/NonAbatixPage';
import NonAbatixAddItemsPage from './Pages/NonAbatix/NonAbatixAddItemsPage';
import NonAbatixProductCategoryPage from './Pages/NonAbatix/NonAbatixProductCategoryPage';
import NonAbatixAuditTrailPage from './Pages/NonAbatix/NonAbatixAuditTrailPage';
import NonAbatixDeletedPage from './Pages/NonAbatix/NonAbatixDeletedPage';
import BinContentsPage from './Pages/BinContentsPage';
import VendingDashboardPage from './Pages/Vending/VendingDashboardPage';
import VendingMachinesPage from './Pages/Vending/VendingMachinesPage';
import VendingMachineDetailPage from './Pages/Vending/VendingMachineDetailPage';
import VendingMachineMappingPage from './Pages/Vending/VendingMachineMappingPage';
import VendingProductMappingPage from './Pages/Vending/VendingProductMappingPage';
import { VendingEmployeeMappingPage } from './Components/Vending/VendingEmployeeMappingPage';
import VendingRestockPage from './Pages/Vending/VendingRestockPage';
import VendingAlertsPage from './Pages/Vending/VendingAlertsPage';
import VendingIntegrationHealthPage from './Pages/Vending/VendingIntegrationHealthPage';
import { VendingTransactionsPage } from './Pages/Vending/VendingTransactionsPage';
import { VendingCustomersPage } from './Pages/Vending/VendingCustomersPage';
import { VendingCustomerDetailPage } from './Pages/Vending/VendingCustomerDetailPage';
import { VendingAuditLogPage } from './Pages/Vending/VendingAuditLogPage';
import { VendingVendorCompaniesPage } from './Pages/Vending/VendingVendorCompaniesPage';
import { isVendingEnabled } from './Services/VendingApi';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <AppLayout>{children}</AppLayout>
);

const App: React.FC = () => {
  return (


    <SnackbarProvider>
    <WidgetPreferencesProvider>

    <Router>
    <Routes>
      <Route path="/" element={<RootRouteRedirect />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />}></Route>
      <Route path="/auth/redirect" element={<MicrosoftRedirect />} />
      <Route path="/auth/logout" element={<Logout />} />
      <Route path="/sms-verification" element={<SmsPage />}></Route>

      <Route path="/transaction-chart" element={<TransactionUsage />}></Route>
  
      <Route element={<ProtectedRoute/>}>
        <Route path="/home" element={<Layout><HomePage /></Layout>} />
        <Route path="/maps" element={<Layout><MapsPage /></Layout>} />
        <Route path="/admin/kits-management" element={<Layout><KitsAndToolsPage /></Layout>} />
        <Route path="/assets/transactions" element={<Layout> <AssetTransactionPage /></Layout>} />
         <Route path="/assets/category" element={<Layout> <AssetCategoryPage /></Layout>} />
      </Route>


  <Route element={<ProtectedRoute minimumRoleLevel={10}/>}>
       <Route path="/abatix/admin/reports" element={<Layout><AbatixAdminAuditReport /></Layout>} />
  </Route>

      <Route element={<ProtectedRoute minimumRoleLevel={10}/>}>
       <Route path="/reports" element={<Layout><TransactionAuditReport /></Layout>} />
       <Route path="/inventory" element={<Layout><InventoryPage /></Layout>} />
       <Route path="/inventory/view-by-bin" element={<Layout><BinContentsPage /></Layout>} />
       <Route path="/transactions" element={<Layout><Transaction /></Layout>} />
       {isVendingEnabled && (
         <>
           <Route path="/vending" element={<Layout><VendingDashboardPage /></Layout>} />
           <Route path="/vending/machines" element={<Layout><VendingMachinesPage /></Layout>} />
           <Route path="/vending/machines/:id" element={<Layout><VendingMachineDetailPage /></Layout>} />
           <Route path="/vending/machines/:id/inventory" element={<Layout><VendingMachineDetailPage /></Layout>} />
           <Route path="/vending/machines/:id/transactions" element={<Layout><VendingMachineDetailPage /></Layout>} />
           <Route path="/vending/machines/:id/alerts" element={<Layout><VendingMachineDetailPage /></Layout>} />
           <Route path="/vending/machines/:id/users" element={<Layout><VendingMachineDetailPage /></Layout>} />
           <Route path="/vending/machines/:id/history" element={<Layout><VendingMachineDetailPage /></Layout>} />
           {/*
             Alternate full-page layouts (tabs are default). To switch UX, replace
             the routes above with:
             VendingMachineAlertsPage, VendingMachineUsersPage, VendingMachineHistoryPage
           */}
           <Route path="/vending/transactions" element={<Layout><VendingTransactionsPage /></Layout>} />
           <Route path="/vending/restock" element={<Layout><VendingRestockPage /></Layout>} />
           <Route path="/vending/alerts" element={<Layout><VendingAlertsPage /></Layout>} />
           <Route path="/vending/customers" element={<Layout><VendingCustomersPage /></Layout>} />
           <Route path="/vending/customers/:cid" element={<Layout><VendingCustomerDetailPage /></Layout>} />
         </>
       )}
       <Route path="/non-abatix" element={<Layout><NonAbatixPage /></Layout>} />
       {/* Non-ABATIX inventory and transactions now live on the shared pages; old links open them pre-filtered. */}
       <Route path="/non-abatix/inventory" element={<Navigate to="/inventory?type=non-abatix" replace />} />
       <Route path="/non-abatix/view-by-bin" element={<Navigate to="/inventory/view-by-bin?type=non-abatix" replace />} />
       <Route path="/non-abatix/transactions" element={<Navigate to="/transactions?type=non-abatix" replace />} />
       <Route path="/non-abatix/add-items" element={<Layout><NonAbatixAddItemsPage /></Layout>} />
       <Route path="/non-abatix/product-category" element={<Layout><NonAbatixProductCategoryPage /></Layout>} />
       <Route path="/non-abatix/audit-trail" element={<Layout><NonAbatixAuditTrailPage /></Layout>} />
       <Route path="/non-abatix/deleted" element={<Layout><NonAbatixDeletedPage /></Layout>} />
       <Route path="/admin/inventory/bin-management" element={<Layout><LocationBinPage /></Layout>} />
       <Route path="/admin/fleet-management" element={<Layout><FleetPage /></Layout>} />
      <Route path="/assets" element={<Layout><AssetPage /></Layout>} />

         
      </Route>

      <Route element={<ProtectedRoute minimumRoleLevel={50}/>}>
      <Route path="/admin/user-management" element={<Layout><UsersPage /></Layout>} />


        <Route path="/admin/location-management" element={<Layout><LocationPage /></Layout>} />
        <Route path="/admin/location/:ovid/po-presets" element={<Layout><LocationPoPresetsPage /></Layout>} />
        <Route path="/admin/gps-management" element={<Layout><GPSPage /></Layout>} />
        <Route path="/settings" element={<Layout><div>Settings Page</div></Layout>} />

      </Route>


      <Route path="/settings/widgets" element={<Layout><WidgetsPage /></Layout>} />
      {isVendingEnabled && (
        <Route element={<ProtectedRoute minimumRoleLevel={100} redirectPath="/vending"/>}>
          <Route path="/vending/mappings" element={<Navigate to="/vending/mappings/machines" replace />} />
          <Route path="/vending/mappings/machines" element={<Layout><VendingMachineMappingPage /></Layout>} />
          <Route path="/vending/mappings/products" element={<Layout><VendingProductMappingPage /></Layout>} />
          <Route path="/vending/mappings/employees" element={<Layout><VendingEmployeeMappingPage /></Layout>} />
          {/* Old per-type URLs (bookmarks, earlier builds) */}
          <Route path="/vending/product-mapping" element={<Navigate to="/vending/mappings/products" replace />} />
          <Route path="/vending/employee-mapping" element={<Navigate to="/vending/mappings/employees" replace />} />
          <Route path="/vending/audit" element={<Layout><VendingAuditLogPage /></Layout>} />
          <Route path="/vending/vendor-companies" element={<Layout><VendingVendorCompaniesPage /></Layout>} />
          <Route path="/vending/integration-health" element={<Layout><VendingIntegrationHealthPage /></Layout>} />
          <Route path="/vending/integration" element={<Layout><VendingIntegrationHealthPage /></Layout>} />
        </Route>
      )}

      <Route element={<ProtectedRoute minimumRoleLevel={100}/>}>
        <Route path="/admin/inventory/deleted" element={<Layout><DeletedInventoryPage /></Layout>} />
        <Route path="/admin/company-management" element={<Layout><CompanyPage /></Layout>} />
        <Route path="/admin/customer-accounts" element={<Layout><CustomerAccountsPage /></Layout>} />
        <Route path="/emails" element={<Layout><EmailPage /></Layout>} />
        <Route path="/admin/failed-orders" element={<Layout><FailedOrdersPage /></Layout>} />
        <Route path="/admin/low-stock-failed-orders" element={<Layout><LowStockFailedOrdersPage /></Layout>} />
        <Route path="/admin/usage-reports" element={<Layout><UsageReportsPage /></Layout>} />
      </Route>

        
  </Routes>
</Router>
</WidgetPreferencesProvider>
</SnackbarProvider>
  );
};

export default App;